export const allowUrls = [
  //
  // https://docs.sentry.io/platforms/javascript/configuration/filtering/
  //

  /https:\/\/(www\.)?((dev|staging)\.)?vaolo\.com/,
];
